import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  Input,
  Optional,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { GroupComponent } from '../../common/group/group.component';
import { IconComponent } from '../../common/icon/icon.component';
import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-button',
  styleUrls: ['./button.component.less'],
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-icon]': 'icon',
    '[class.has-dropdown]': 'dropdown',
    '[class.loading]': 'loading',
    '[class.disabled]': 'disabled',
    '[attr.tabindex]': 'tabIndex',
    '[class.has-right-margin]': 'hasRightMargin',
    '[class.small-label]': 'hasSmallLabel',
    '[class.text-color-white]': 'hasTextColorWhite',
    '[class.underline-heading-on-hover]': 'hasUnderlinedHeadingOnHover',
    '[class.has-text-uppercase]': 'hasTextUppercase',
    '[class.has-no-hover-state]': 'hasNoHoverState',
    '[class.has-no-active-state]': 'hasNoActiveState',
    '[class.is-small-and-inline]': 'isSmallAndInline',
    '[class.hide-text-content]': 'hideTextContent',
    '[class.icon-inline-block]': 'iconInlineBlock',
    '[class.padding-small]': 'paddingSmall',
    '[class.dropdown-icon-dark]': 'dropdownIconDark',
    '[class.no-underline]': 'noUnderline',
    '[class.is-tight]': 'isTight',
    '[class.has-no-margin]': 'hasNoMargin',
    '[class.placeholder]': 'hasPlaceholderStyles',
    '[class.inside-input]': 'insideInput',
    '[class.green-on-active]': 'greenOnActive',
    '[class.icon-on-active]': 'showIconOnActive',
    '[class.has-white-background]': 'hasWhiteBackground',
    '[class]': 'variant',
  },
})
export class ButtonComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'primary',
      'simple',
      'plain',
      'underlined',
      'small', // TODO: Legacy, to be removed
      'small-x',
      'small-xx',
      'large',
      'large-x',
      'only-icon',
      'oval',
      'add-element',
      'centered',
      'danger',
      'danger-on-hover',
      'no-padding',
      'switcher',
      'cursor-default',
      'toggle',
      'success',
      'error',
      'warning',
      'notification',
      'follow',
      'outline',
      'outline--dashed',
      'primary-outline',
      'transparent',
      'candidate',
      'is-first',
      'is-last',
      'icon-light',
      'color-light',
      'truncate',
      'outline-on-hover',
      'dropdown',
      'has-icon',
      'icon-right',
      'keep-radius',
      'more',
      'primary-on-hover',
    ],
  ];
  @Input()
  @ComponentVariant(ButtonComponent.VARIANTS)
  public variant: string;
  @ContentChild(IconComponent) public icon: IconComponent;
  @Input() public loading: boolean = false;
  @Input() public dropdown: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public href: SafeUrl | string | null = null;
  @Input() public hrefTarget: string | null = null;
  @Input() public tabIndex: number;
  @Input() public hasDownloadAttribute: boolean = false;
  @Input() public spinnerColor: boolean = false;
  @Input() public hasRightMargin: boolean = false;
  @Input() public hasSmallLabel: boolean = false;
  @Input() public hasTextColorWhite: boolean = false;
  @Input() public hasTextUppercase: boolean = false;
  @Input() public hasUnderlinedHeadingOnHover: boolean = false;
  @Input() public hasNoHoverState: boolean = false;
  @Input() public isSmallAndInline: boolean = false;
  @Input() public hasFullWidthContent: boolean = false;
  @Input() public hideTextContent: boolean = false;
  @Input() public hasNoActiveState: boolean = false;
  @Input() public iconInlineBlock: boolean = false;
  @Input() public paddingSmall: boolean = false;
  @Input() public dropdownIconDark: boolean = false;
  @Input() public noUnderline: boolean = false;
  @Input() public isTight: boolean = false;
  @Input() public hasNoMargin: boolean = false;
  @Input() public hasPlaceholderStyles: boolean = false;
  @Input() public insideInput: boolean = false;
  @Input() public greenOnActive: boolean = false;
  @Input() public showIconOnActive: boolean = false;
  @Input() public hasWhiteBackground: boolean = false;
  @Input() public preventDefault: boolean = false;

  constructor(public elRef: ElementRef, @Optional() private group: GroupComponent) {}

  public setFocus(): void {
    if (this.elRef.nativeElement) {
      this.elRef.nativeElement.focus();
    }
  }

  /*
   * After button refactor merge this can be removed
   */
  public onHrefClick(event: MouseEvent): boolean {
    if (this.preventDefault) {
      event.preventDefault();
      return false;
    }

    return true;
  }
}
